export const isDocument = (el: any): el is Document => el.nodeType === Node.DOCUMENT_NODE
